import React from "react";
import "./styles/css/App.css";
import Home from "./sections/Home";
import Introduction from "./sections/Introduction";
import Contact from "./sections/Contact";
import Features from "./sections/Features";

function App() {
  return (
    <div className="App">
      <header>
        <Navbar />
      </header>
      <main>
        <Home />
        <Introduction />
        <Features />
        <Contact />
      </main>
      <footer class="footer">
        <div class="content has-text-centered">
          <p>&copy; Copyright 2020, Yakoi</p>
        </div>
      </footer>
    </div>
  );
}

function Navbar() {
  const [isActive, setIsActive] = React.useState(false);

  function open() {
    setIsActive(true);
  }

  function close() {
    setIsActive(false);
  }

  return (
    <nav
      className="navbar is-fixed-top has-shadow"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container">
        <div className="navbar-brand">
          <a className="navbar-item" href="/">
            <img src="./images/yakoi_logo.svg" />
          </a>
          <a
            role="button"
            className={"navbar-burger burger " + (isActive ? "is-active" : "")}
            aria-label="menu"
            aria-expanded="false"
            data-target="navbar"
            onClick={(e) => setIsActive(!isActive)}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div
          id="navbar"
          className={"navbar-menu " + (isActive ? "is-active" : "")}
        >
          <div className="navbar-start">
            <a className="navbar-item" href="#home" onClick={() => close()}>
              Acceuil
            </a>
            <a
              className="navbar-item"
              href="#introduction"
              onClick={() => close()}
            >
              Présentation
            </a>
            <a className="navbar-item" href="#features" onClick={() => close()}>
              Fonctionnalités
            </a>
            <a className="navbar-item" href="#contact" onClick={() => close()}>
              Contact
            </a>
            <a
              className="navbar-item"
              onClick={() => close()}
              href="https://github.com/yakoi-l2af2-2020/yakoi"
              target="_blank"
            >
              GitHub
            </a>
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <div className="buttons">
                <a
                  className="button is-primary"
                  href="/resources/yakoi-4641170c5c6a422cb24c4417dd01e5dd-signed.apk"
                  download="yakoi-4.0.apk"
                >
                  <span className="icon">
                    <i className="fas fa-download" />
                  </span>
                  <span>Télécharger</span>
                </a>
                <a className="button is-primary is-light">
                  <span className="icon">
                    <i class="fas fa-user-plus"></i>
                  </span>
                  <span>S'inscrire</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default App;
